module.exports = __webpack_public_path__ + "01_glasses_red.52105e04.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer4/01_glasses_red.png
// module id = rRcV
// module chunks = 0